import i18n from '@dinosband/bv-i18n'
import { types } from '../types'
import type { Store } from '../store'

export function getProcessOfChatRoom (chatRoom: types.ChatRoom): types.ChatRoomProcess {
  return parseChatRoomProcess(chatRoom.process)
}

export function parseChatRoomProcess (processString?: string | null): types.ChatRoomProcess {
  const process = JSON.parse(processString ?? '{}') as types.ChatRoomProcess
  // backward compatibility: clentActions와 providerActions가 정의안 된 경우에는 ownerActions와 applicantActions를 복사
  if (process.ownerActions && !process.clientActions) {
    process.clientActions = process.ownerActions
  }
  if (process.applicantActions && !process.providerActions) {
    process.providerActions = process.applicantActions
  }
  return process
}

export function cloneProcess (src: types.ChatRoomProcess): types.ChatRoomProcess {
  return makeBackwardCompatible({
    type: src.type,
    states: src.states.map((state) => Object.assign({}, state) as types.ProcessState),
    clientActions: src.clientActions.map((action) => Object.assign({}, action) as types.ProcessAction),
    providerActions: src.providerActions.map((action) => Object.assign({}, action) as types.ProcessAction),
  })
}

export function getApplyActionName (store: Store, actionName?: string) {
  if (!actionName) {
    return i18n.tc('strings.src.mesg-processutils01')
  }
  return i18n.tc('strings.src.mesg-processutils02', 1, { actionName: store.translate(actionName) })
  // if (actionName.search('하기') == actionName.length - 2) {
  //   return actionName
  // } else {
  //   return actionName + '하기'
  // }
}

export function getActionsOfApplicant (process: types.ChatRoomProcess | undefined): types.ProcessAction[] {
  if (process) {
    const clientActions = process.clientActions
    const providerActions = process.providerActions
    return process.providerPost ? clientActions : providerActions
  }
  return []
}

export function getActionsOfOwner (process: types.ChatRoomProcess | undefined): types.ProcessAction[] {
  if (process) {
    const clientActions = process.clientActions
    const providerActions = process.providerActions
    return process.providerPost ? providerActions : clientActions
  }
  return []
}

export function makeBackwardCompatible (process: types.ChatRoomProcess) {
  process.ownerActions = process.clientActions
  process.applicantActions = process.providerActions
  return process
}
